import { Component, OnInit, Output, EventEmitter  } from '@angular/core';

@Component({
  selector: 'app-button-list-guardar',
  templateUrl: './button-list-guardar.component.html',
  styleUrls: ['./button-list-guardar.component.css']
})
export class ButtonListGuardarComponent implements OnInit {

  ListaBotnesItems  = 
  [ {icon:'save',label:'Guardar',principal:true, action:'GUARDAR'},
    {icon:'featured_play_list',label:'Guardar y Continuar',principal:false, action:'GUARDAR_CONTINUAR'}
   ];
   @Output('on-click') onClickEvent: EventEmitter<any> = new EventEmitter();
  constructor() { }

  ngOnInit() {
  }

  accionClickList($event : any) {
    this.onClickEvent.emit($event);
  }
}
